import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { useExtraActions, useLoginActions } from '_actions';
import { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import { storesAtom } from "_state";
import { Alert } from "_components";

export { Login };

function Login() {
    const loginActions = useLoginActions();
    const stores = useRecoilValue(storesAtom);

    // form validation rules 
    const validationSchema = Yup.object().shape({
        tienda: Yup.string().required('Debe seleccionar la tienda donde realizó la compra'),
        ticket: Yup.string().required('El número de la venta es requerido, lo encontrarás en el ticket y/o remisión')
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, formState, setValue } = useForm(formOptions);
    const { errors, isSubmitting } = formState;
    const extraActions = useExtraActions();

    const [selectedRadio, setSelectedRadio] = useState("1");

    const handleChangeValue = (e) => {
        setSelectedRadio(e.target.value);
        
        const firstStore = stores.filter(s => s.storeType == e.target.value);
        setValue('tienda', firstStore.length < 1 ? "1" : firstStore[0].id, { shouldValidate: true })
    }

    useEffect(() => {
        localStorage.clear();
        extraActions.resetPayments();
        loginActions.getAllStores();
        setValue('tienda', "1", { shouldValidate: true });
        return loginActions.resetUsers;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <main>
            <div className='bd-masthead'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-8 mx-auto text-center'>
                            <img src={`${process.env.PUBLIC_URL}/logo_solo.png`} alt="logo" />
                            <h1 className='mb-3 pb-3 fw-semibold'>Descarga tu factura o imprímela</h1>
                            <p className='mb-5 pb-5 lead'>Realiza tus facturas en tiempo y forma. El servicio de Facturación Electrónica es para tí. ¡Úsalo!</p>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6 mx-auto pleca p-5 rounded'>
                            <form onSubmit={handleSubmit(loginActions.login)}>
                                <div className="form-group pb-2 text-center">
                                    <legend>Selecciona dónde realizaste tu compra</legend>
                                    <div className="form-check form-check-inline">
                                        <input id="IsCredit" type="radio" name="POStype" className="form-check-input" defaultChecked value='1' onChange={handleChangeValue} />
                                        <label htmlFor="IsCredit">Página de internet</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input id="IsCASA" type="radio" name="POStype" className="form-check-input" value='2' onChange={handleChangeValue} />
                                        <label htmlFor="IsCASA">C.A.S.A.</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input id="IsCB" type="radio" name="POStype" className="form-check-input" value='3' onChange={handleChangeValue} />
                                        <label htmlFor="IsCB">Centro de belleza</label>
                                    </div>
                                </div>
                                <div className="form-group pb-2">
                                    <label>Tienda / C.A.S.A.</label>
                                    <select name="tienda" {...register('tienda')} disabled={selectedRadio == "1"} 
                                        className={`form-control ${errors.tienda ? 'is-invalid' : ''}`}
                                        onChange={(e) => setValue('tienda', e.target.value, { shouldValidate: true })} >
                                        {
                                            selectedRadio != "1" && stores?.filter(s => s.storeType == selectedRadio).map(store =>
                                                <option key={store.id} value={store.id}>{store.description}</option>
                                            )
                                        }
                                    </select>
                                    <div className="invalid-feedback">{errors.tienda?.message}</div>
                                </div>
                                <div className="form-group pb-2">
                                    <label>Número de venta</label>
                                    <input name="ticket" type="text" {...register('ticket')} className={`form-control ${errors.ticket ? 'is-invalid' : ''}`} />
                                    <div className="invalid-feedback">{errors.ticket?.message}</div>
                                </div>
                                <Alert />
                                <button disabled={isSubmitting} className="btn btn-primary mt-2">
                                    {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                    Consultar
                                </button>
                            </form>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-8 text-center mx-auto">
                            <p className='lead'>Si no encuentras tu factura o es anterior al 07 de Junio de 2022.<br />Por favor descargala <a href="https://www.yrasesoras.com.mx/FacturacionElectronica33/" target='_blank'>desde aquí</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}
